// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".overflow-body[data-v-1aee5bb3]{overflow-y:auto!important;max-height:76vh}.modal-custom[data-v-1aee5bb3]{max-height:70vh!important}", ""]);
// Exports
module.exports = exports;
